import React from "react"
import SliceZone from "../../../../utils/SliceZone"
import {
	Container,
	TopContainer,
	FeaturedImage,
	Category,
	Title,
	Blurb,
	Date,
} from "./ArticleBody.styles"
import { PostFooter } from "../PostFooter/PostFooter"
import { ArticleFooter } from "../ArticleFooter/ArticleFooter"
import moment from "moment"
import { PrismicRichText } from "@prismicio/react"
import { SEO } from "../../../../utils/SEO"

export const ArticleBody = ({ data }) => {
	const toplevel = data

	data = data.results[0].data

	const { title, body, blurb, featured_image } = data
	const { url, alt } = featured_image
	const categories = data.categories

	const author = data.author_name[0]?.text
	const date = data.published_date
	const formatted = moment(date).format("MMM DD, YYYY")

	return (
		<Container>
			<SEO data={data} />
			<TopContainer>
				<FeaturedImage src={url} alt={alt} />
				<Category>
					{categories.map((category, i) => {
						return (
							<TopCategories
								title={category.category.slug}
								index={i}
								length={categories.length}
								key={category.category.slug}
							></TopCategories>
						)
					})}
				</Category>
				<Title>{title[0].text}</Title>
				<Blurb>{<PrismicRichText field={blurb} />}</Blurb>

				<Date>
					{formatted} {author && <span>/ {author} </span>}
				</Date>
				{/* Body content */}
			</TopContainer>
			<SliceZone sliceZone={body} />
			<PostFooter data={toplevel}></PostFooter>
			<ArticleFooter data={data} />
		</Container>
	)
}

function TopCategories(props) {
	let length = props.length - 1
	if (props.index != length && length >= 1) {
		return <>{props.title},</>
	} else {
		return <>{props.title}</>
	}
}
